export enum MODAL_SIZE {
  SMALL = `SMALL`,
  MEDIUM = `MEDIUM`,
  LARGE = `LARGE`,
}

export const MODAL_SIZES = {
  SMALL: MODAL_SIZE.SMALL,
  MEDIUM: MODAL_SIZE.MEDIUM,
  LARGE: MODAL_SIZE.LARGE,
};

export enum MODAL_TYPE {
  DEFAULT = `DEFAULT`,
  SKILL = `SKILL`,
  SHOWCASE = `SHOWCASE`,
}

export const MODAL_TYPES = {
  DEFAULT: MODAL_TYPE.DEFAULT,
  SKILL: MODAL_TYPE.SKILL,
  SHOWCASE: MODAL_TYPE.SHOWCASE,
};
